import { withForm } from '@/core/form/withForm';
import { Input as BaseInput } from '@/components/atoms/Form/Input';

export const Input = withForm(BaseInput);
